import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    isLoading: false,
    error: null,
    results: [],
    total: 0,
    summary: { jobs: 0, disputes: 0, unpaidInvoices: 0, amountAtStake: 0 },
    // Last list query, reused to refresh the page after an action.
    query: { page: 1, limit: 10, search: '', province: '' },
    // _id of the job an action (resolve / pay / edit tracker) is running on.
    busyJobId: null,
};

const slice = createSlice({
    name: 'disputes',
    initialState,
    reducers: {
        fetchDisputes: (state, { payload }) => {
            state.isLoading = true;
            state.error = null;
            state.query = { ...state.query, ...payload };
        },
        disputesFetched: (state, { payload }) => {
            state.results = payload.results || [];
            state.total = payload.total || 0;
            state.summary = payload.summary || initialState.summary;
            state.isLoading = false;
        },
        disputesFetchFailed: (state, { payload }) => {
            state.isLoading = false;
            state.error = payload || 'Failed to load disputes';
        },
        resolveDispute: (state, { payload }) => {
            state.busyJobId = payload.jobId;
        },
        payAndResolveDispute: (state, { payload }) => {
            state.busyJobId = payload.jobId;
        },
        editDisputeTracker: (state, { payload }) => {
            state.busyJobId = payload.job._id;
        },
        disputeActionDone: state => {
            state.busyJobId = null;
        },
    },
});

export const {
    fetchDisputes,
    disputesFetched,
    disputesFetchFailed,
    resolveDispute,
    payAndResolveDispute,
    editDisputeTracker,
    disputeActionDone,
} = slice.actions;

export const selectDisputesState = state => state.disputes;

export default slice.reducer;
